import { newAppointmentPath } from "../pages/schedule/scheduleLinks";

export const AppointmentTaskStatus = {
  PENDING: "pending",
  COMPLETED: "completed",
} as const;

export type AppointmentTaskStatus =
  (typeof AppointmentTaskStatus)[keyof typeof AppointmentTaskStatus];

/** Optional inline action rendered on the right of a task row. */
export interface AppointmentTaskAction {
  label: string;
  /** In-app route handed to `navigate()`. */
  to: string;
}

export interface AppointmentTask {
  id: string;
  title: string;
  subtitle?: string;
  status: AppointmentTaskStatus;
  action?: AppointmentTaskAction;
}

export const FOLLOW_UP_APPOINTMENT_TASK_ID = "follow-up-appointment";

export const buildVisitActionTasks = (patientId: string): AppointmentTask[] => [
  {
    id: FOLLOW_UP_APPOINTMENT_TASK_ID,
    title: "Book Follow Up Appointment",
    subtitle: "Patient will be preselected",
    status: AppointmentTaskStatus.PENDING,
    action: { label: "Schedule", to: newAppointmentPath(patientId) },
  },
];

/** Narrowing guard used when rehydrating persisted state from storage. */
export const isAppointmentTask = (value: unknown): value is AppointmentTask => {
  if (typeof value !== "object" || value === null) return false;
  const task = value as Partial<AppointmentTask>;
  return (
    typeof task.id === "string" &&
    typeof task.title === "string" &&
    (task.status === AppointmentTaskStatus.PENDING ||
      task.status === AppointmentTaskStatus.COMPLETED)
  );
};
